import { useCallback, useEffect, useRef } from 'react';

export interface Point {
  x: number;
  y: number;
}

export interface ScrollCallbackProps {
  previousPosition: Point;
  currentPosition: Point;
}

const isBrowser = typeof window !== 'undefined';

function getScrollPosition() {
  if (!isBrowser) {
    return {
      x: 0,
      y: 0,
    };
  }

  const position = document.body.getBoundingClientRect();

  return {
    x: position.left,
    y: position.top,
  };
}

export function useScrollPosition(onScrollCallback: (props: ScrollCallbackProps) => void) {
  const previousPosition = useRef(getScrollPosition());

  const handleScroll = useCallback(() => {
    const currentPosition = getScrollPosition();
    onScrollCallback({
      previousPosition: previousPosition.current,
      currentPosition,
    });
    previousPosition.current = currentPosition;
  }, [onScrollCallback]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, {
      capture: true,
      passive: true,
    });
    return () =>
      window.removeEventListener('scroll', handleScroll, {
        capture: true,
      });
  }, [handleScroll]);
}
